import { render, staticRenderFns } from "./whsHeader.vue?vue&type=template&id=513e018c&scoped=true&"
import script from "./whsHeader.vue?vue&type=script&lang=js&"
export * from "./whsHeader.vue?vue&type=script&lang=js&"
import style0 from "./whsHeader.vue?vue&type=style&index=0&id=513e018c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e018c",
  null
  
)

export default component.exports